export enum ActionTypes {
  Add = '[Product] Add to cart',
  GetConnections = '[Product] Remove from cart',
  SetActiveConversation = '[Product] Fmm from cart',
  PushConversation = '[Product] Duh from cart',
  UpdateConversation = '[Product] Update from cart',
  SetMessageRead = '[Product] Set from cart',
  SetAds = '[Product] Setd from cart',
  SetLocations = '[Product] Setdd from cart'
}

export const GetConversations = payload => {
  return {
    type: ActionTypes.Add,
    payload
  };
};

export const GetConnections = payload => {
  return {
    type: ActionTypes.GetConnections,
    payload
  };
};

export const SetActiveConversation = payload => {
  return {
    type: ActionTypes.SetActiveConversation,
    payload
  };
};

export const PushConversation = payload => {
  return {
    type: ActionTypes.PushConversation,
    payload
  };
};

export const UpdateConversation = payload => {
  return {
    type: ActionTypes.UpdateConversation,
    payload
  };
};

export const SetMessageRead = payload => {
  return {
    type: ActionTypes.SetMessageRead,
    payload
  };
};

export const SetAds = payload => {
  return {
    type: ActionTypes.SetAds,
    payload
  };
};

export const SetLocations = payload => {
  return {
    type: ActionTypes.SetLocations,
    payload
  };
};






